module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h2', {
    staticClass: "fm_title"
  }, [_vm._v("List of Plates")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Spartan points out a drunken slave to his sons; painting by Fernand Sabatte, 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Persian combat engineer mounted on a donkey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The entrance to the Temple of Apollo at Delphi.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Persian archer, from an Athenian black-figure vase.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Greek infantry depicted on a frieze.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The Leonidian in modern Sparta.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The view across Sparta to Mt Parnon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A contemporary woman’s jewellery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A mother arms her son before battle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mount Ithome depicted in an 1882 woodcut.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The medieval monastery at Mystras.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("King Nabis, portrait taken from a contemporary coin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Philip II of Macedon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The Spartan acropolis looking west across modern Sparta.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Modern Sparta with the Taygetos range in the background.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The remains of the theatre, as seen from the Spartan acropolis.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The remains of the walls of Sparta.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A single olive tree of tough wood, illustrating the difficulty of destroying even a few acres of such trees.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7512192d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List_of_Plates.vue
// module id = 69
// module chunks = 0